import { useTranslation } from 'react-i18next'

import { CopyIcon, DotsThreeCircleVerticalIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton, PackageCheckIcon } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PackagingItemMenu = ({ data, onEdit, onDelete, onDuplicate, onSetDefault }) => {
  const { t } = useTranslation()

  const menuItems = [
    {
      label: (
        <Styles.MenuItem>
          <PencilSimpleIcon />
          {t('Editar')}
        </Styles.MenuItem>
      ),
      onClick: () => onEdit(data),
    },
    {
      label: (
        <Styles.MenuItem>
          <CopyIcon />
          {t('Duplicar')}
        </Styles.MenuItem>
      ),
      onClick: () => onDuplicate(data),
    },
    {
      label: (
        <Styles.MenuItem>
          <PackageCheckIcon size={16} />
          {t('Seleccionar como predeterminado')}
        </Styles.MenuItem>
      ),
      onClick: () => onSetDefault(data?.id),
    },
    {
      label: (
        <Styles.MenuItem>
          <TrashIcon />
          {t('Eliminar')}
        </Styles.MenuItem>
      ),
      onClick: () => onDelete(data?.id),
    },
  ]

  return (
    <ButtonMenu
      stopPropagation
      menuItems={menuItems}
      renderButton={onClick => (
        <IconButton
          onClick={onClick}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon size={22} weight="light" data-testid="packaging-item-menu" />}
        />
      )}
    />
  )
}

export default PackagingItemMenu
